import { buildIndex } from '@adalo/utils'
import { adaloBackendAxios } from 'utils/io/http/axios'

const FETCH_TCI_ORGANIZATIONS = 'FETCH_TCI_ORGANIZATIONS'
const FETCH_TCI_ORGANIZATION_USERS = 'FETCH_TCI_ORGANIZATION_USERS'
const DOWNGRADE_TCI_ORGANIZATION = 'DOWNGRADE_TCI_ORGANIZATION'
const UPGRADE_TCI_ORGANIZATION = 'UPGRADE_TCI_ORGANIZATION'
const UPDATE_TCI_ORGANIZATION_SUBSCRIPTION =
  'UPDATE_TCI_ORGANIZATION_SUBSCRIPTION'

export const INITIAL_STATE = {
  organization: {},
  users: [],
  organizations: {},
  currentOrganization: null,
  currentOrganizationId: null,
  pagination: {
    total: 0,
    offset: 0,
    limit: 20,
  },
  loading: false,
}

export default (state = INITIAL_STATE, action) => {
  if (action?.type === FETCH_TCI_ORGANIZATIONS) {
    return {
      ...state,
      loading: true,
    }
  }

  if (action?.type === `${FETCH_TCI_ORGANIZATIONS}_FULFILLED`) {
    const data = action.payload?.data || {}
    const organizations = buildIndex(data?.organizations || [], org => org.id)
    const pagination = data?.pagination || state.pagination

    return {
      ...state,
      organizations,
      pagination,
      loading: false,
    }
  }

  if (action?.type === `${FETCH_TCI_ORGANIZATIONS}_REJECTED`) {
    return {
      ...state,
      loading: false,
    }
  }

  if (action?.type === `${FETCH_TCI_ORGANIZATION_USERS}_FULFILLED`) {
    const organization = action.payload?.data?.organization
    const users =
      action.payload?.data?.users.map(user => ({
        ...user,
        isAdmin: user?.OrganizationUsers[0]?.isAdmin,
      })) || []

    return {
      ...state,
      organization,
      users,
    }
  }

  if (action?.type === `${DOWNGRADE_TCI_ORGANIZATION}_FULFILLED`) {
    const organizationId = action?.payload?.data?.id
    const organizations = state.organizations

    organizations[organizationId] = {
      ...organizations[organizationId],
      active: false,
    }

    return {
      ...state,
      organizations,
    }
  }

  if (action?.type === `${UPGRADE_TCI_ORGANIZATION}_FULFILLED`) {
    const organizationId = action?.payload?.data?.id
    const organizations = state.organizations

    organizations[organizationId] = {
      ...organizations[organizationId],
      active: true,
    }

    return {
      ...state,
      organizations,
    }
  }

  if (action?.type === `${UPDATE_TCI_ORGANIZATION_SUBSCRIPTION}_FULFILLED`) {
    const organizationId = action?.payload?.data?.id
    const organizations = state.organizations

    organizations[organizationId] = {
      ...organizations[organizationId],
      planType: action?.payload?.data?.planType,
      active: action?.payload?.data?.active,
    }

    return {
      ...state,
      organizations,
    }
  }

  return state
}

export const fetchTCIOrganizations = (offset = 0, limit = 20, search = '') => {
  const params = new URLSearchParams()
  params.append('offset', offset.toString())
  params.append('limit', limit.toString())
  if (search) {
    params.append('search', search)
  }

  return {
    type: FETCH_TCI_ORGANIZATIONS,
    payload: adaloBackendAxios.get(`/tci/organizations?${params.toString()}`),
  }
}

export const fetchTCIOrganizationUsers = id => ({
  type: FETCH_TCI_ORGANIZATION_USERS,
  payload: adaloBackendAxios.get(`/tci/organizations/${id}/users`),
})

export const downgradeTCIOrganization = id => ({
  type: DOWNGRADE_TCI_ORGANIZATION,
  payload: adaloBackendAxios.put(`/tci/organizations/${id}/downgrade`),
})

export const upgradeTCIOrganization = id => ({
  type: UPGRADE_TCI_ORGANIZATION,
  payload: adaloBackendAxios.put(`/tci/organizations/${id}/upgrade`),
})

export const updateTCIOrganizationSubscription = (
  id,
  planType,
  active = true
) => ({
  type: UPDATE_TCI_ORGANIZATION_SUBSCRIPTION,
  payload: adaloBackendAxios.put(`/tci/organizations/${id}/subscription`, {
    planType,
    active,
  }),
})

/**
 * @param {Object} state
 * @returns {Array<import('../../components/TCI/types').Organization>}
 */
export const getOrganizations = state => {
  const organizations = Object.values(state?.tci?.organizations || {})

  return organizations
}

export const getOrganizationUsers = state => {
  const organization = state?.tci?.organization || {}
  const users = state?.tci?.users || []

  return { organization, users }
}

/**
 * @param {Object} state
 * @returns {{total: number, offset: number, limit: number}}
 */
export const getPagination = state => {
  return state?.tci?.pagination || { total: 0, offset: 0, limit: 20 }
}

/**
 *
 * @param {Object} state
 * @returns {boolean}
 */
export const getLoading = state => {
  return state?.tci?.loading || false
}
